import { type ReactNode, useState } from 'react';
import { Spinner } from '@/components/ui/spinner';
import {
  usePricingRanges,
  type PricingRange,
} from '@/hooks/use-pricing-ranges';
import { type RangeFormMode } from './range-form-modal';
import {
  PageHeader,
  RangeList,
  useDeleteHandler,
  AddRangeButton,
  RangeModals,
} from './pricing-page-parts';

export function PricingPage(): ReactNode {
  const { data, isLoading } = usePricingRanges();
  const handleDelete = useDeleteHandler();
  const [formMode, setFormMode] = useState<RangeFormMode | null>(null);
  const [historyId, setHistoryId] = useState<string | null>(null);
  if (isLoading || !data) return <Spinner />;
  const list = {
    ranges: data.ranges,
    onEdit: (r: PricingRange) => setFormMode({ kind: 'edit', range: r }),
    onHistory: setHistoryId,
    onDelete: handleDelete,
  };
  const modals = { formMode, setFormMode, historyId, setHistoryId };
  return (
    <div className="space-y-lg">
      <PageHeader count={data.current_count} />
      <RangeList {...list} />
      <AddRangeButton onClick={() => setFormMode({ kind: 'create' })} />
      <RangeModals {...modals} />
    </div>
  );
}
